import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { UserService } from '@core/services';

@Component({
  selector: 'app-logged-in-as',
  templateUrl: './logged-in-as.component.html',
  styleUrls: ['./logged-in-as.component.css']
})
export class LoggedInAsComponent implements OnInit, OnDestroy {

  public user: any;
  private userSubscription: Subscription;

  constructor(private _userService: UserService) {
  }

  ngOnInit() {
    this.userSubscription = this._userService.getUser().subscribe(user => this.user = user);
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/logged-in-as/logged-in-as.component.ts